// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"da3ee6a8","230":"dfd2b62f"}[chunkId] + ".chunk.css";
};